<template>
	<div class="drawer">
		<el-drawer
		size="400px"
		:visible.sync="drawerStatus"
		@close='handleClose'
		>
			<img src="../../assets/img/remark.png" class="avatar" style="width:200px;"/>
			<el-form :inline="true" class="form">
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="24">
							<el-form-item label="备注:" :label-width="formLabelWidth">
								<el-input v-model="remark" type="textarea" :rows="5" style="width:300px;" placeholder="请输入"></el-input>
							</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div style="height: 40px;width:100%;"></div>
			<div class="btnBox">
				<div class="btnItem" @click="handleClose">取消</div>
				<div class="btnItem submit" @click="submitCode">确定</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				formLabelWidth:'60px',
				remark:'',
			}
		},
		props:{
			state:{
				default:false,
			},
			str:{
				default:''
			}
		},
		watch:{
			state(n){
				this.drawerStatus = n
			}
		},
		mounted(){
		},
		methods: {
			handleClose(){
				this.$emit('submit',{type:'close'})
			},
			submitCode(){
				this.$emit('submit',{type:'success',data:this.remark})
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.avatar{
				width:300px;
				display: block;
				margin:60px auto 80px;
			}
			.form{
				::v-deep .el-form-item{
					margin:5px 0;
				}
			}
		}
		
	}
	.btnBox{
		width:100%;font-size: 14px;color:#fff;line-height: 40px;display: flex;position: absolute;bottom: 0;z-index: 10;
		.btnItem{
			text-align: center;width:100%;background-color: #D6D6D6;cursor: pointer;
			&.submit{
				background-color: $mainColor;
			}
		}
	}
</style>
